export default __webpack_public_path__ + "static/media/adi-learning-hub.6c6a193d.svg";